import { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import findConsultaLote from '../../service/findConsultaLote';
import { SortOrder } from 'primereact/api';
import { Button } from 'primereact/button';
import getConsultaLoteDownloadResultado from '../../service/getConsultaLoteDownloadResultado';




export default function ConsultaLoteList() {
  const { t } = useTranslation();
  const [consultasLote, setConsultasLote] = useState(undefined);
  const [totalRecords, setTotalRecords] = useState(0);
  
  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 10,
    page: 1,
    sortField: 'dataInclusao',
    sortOrder: SortOrder.DESC
  });

  const onPage = (event: any) => {
    setlazyState({
      first: event.first,
      rows: event.rows,
      page: (event.first / event.rows) + 1,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };
  const onSort = (event:any) => {
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };

  const loadLazyData = () => {
    findConsultaLote(lazyState).then(data => {setTotalRecords(data.total);setConsultasLote(data.consultasLote)}).catch(() => {setTotalRecords(0);setConsultasLote(undefined)});
  }

  const downloadResponse = (consulta: any) => {
      getConsultaLoteDownloadResultado(consulta.id).then((blobFile: Blob) => {
        const url = window.URL.createObjectURL(
          new Blob([blobFile], { type: "octet/stream" })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `resultado.csv`);
  
        // Append to html link element page
        document.body.appendChild(link);
  
        // Start download
        link.click();
  
        // Clean up and remove the link
        document.body.removeChild(link);
      });
    };

  const downloadTemplate = (consulta: any) => {
      return (
        <>
          {
            consulta.status == "Processado" && (
              <Button
                icon="pi pi-download"
                onClick={() => {
                  downloadResponse(consulta);
                }}
                style={{
                  background: "transparent",
                  color: "gray",
                  border: "none",
                }}
              />
            )}
          
        </>
      );
    };
  
  useEffect(() => {
    loadLazyData();
  },[lazyState])

  return (
    <div>
      <div>
        <DataTable value={consultasLote} first={lazyState.first} dataKey="id" paginator={true}  lazy={true}
                        emptyMessage="Sem registros"
                        onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
                        rows={lazyState.rows} totalRecords={totalRecords} onPage={onPage}
                        tableStyle={{ minWidth: '75rem' }}>
           <Column field="dataInclusao" sortable header={t('dtInclusao')}  />
           <Column field="opcaoConsultaLote" sortable header={t('opcao')}  />
           <Column field="status" sortable header={t('status')}  />
           <Column field="quantidadeRegistro" sortable header={t('quantidadeRegistro')}  />
           <Column field="quantidadeSucesso" sortable header={t('quantidadeSucesso')}  />
           <Column field="quantidadeErro" sortable header={t('quantidadeErro')}  />
           <Column style={{width: '11%'}} body={downloadTemplate} />
        </DataTable> 
      </div>
    </div>
  )
}


